<template>
    <b-card no-body class="h-100">
        <b-card-body>
            <b-tabs>
                <b-tab active>
                    <template slot="title">
                        Subitens
                    </template>
                    <div class="pt-3" v-if="!item">
                        <p class="text-muted text-center my-5">
                            Selecione um item do contrato
                        </p>
                    </div>
                    <div class="pt-3" v-else-if="!item.possuiSubitens">
                        <p class="text-muted text-center my-5">
                            O item selecionado não contém subitens
                        </p>
                    </div>
                    <div class="pt-3" v-else>
                        <b-row>
                            <b-col sm="12" md="4">
                                <b-form-input
                                    type="text"
                                    placeholder="Buscar subitem..."
                                    v-model="busca"
                                    class="mb-3"
                                ></b-form-input>
                            </b-col>
                            <b-col sm="12" md="3">
                                <b-form-select
                                    v-model="statusFiltro"
                                    :options="opcoesStatus"
                                    class="mb-3"
                                ></b-form-select>
                            </b-col>
                            <b-col sm="12" md="5">
                                <b-button
                                    variant="primary"
                                    class="mb-3 float-right"
                                    :disabled="naoIntegradosFiltrados.length === 0"
                                    @click="marcarNaoIntegrados()"
                                    >Marcar os
                                    {{ naoIntegradosFiltrados.length }}
                                    não integrados</b-button
                                >
                            </b-col>
                        </b-row>
                        <app-tabela
                            idTabela="tblSubItensSelecao"
                            :itens="subItensFiltrados"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :mostrarFiltro="false"
                            :bordered="false"
                            :small="true"
                        >
                            <template slot="selecao" slot-scope="data">
                                <b-form-checkbox
                                    :checked="estaSelecionado(data)"
                                    :disabled="travado(data)"
                                    :title="tituloCheckbox(data)"
                                    @change="$emit('alternar', data)"
                                ></b-form-checkbox>
                            </template>
                            <template
                                slot="statusIntegracao"
                                slot-scope="data"
                            >
                                <b-badge :variant="variante(data)">{{
                                    descricaoStatus(data)
                                }}</b-badge>
                            </template>
                        </app-tabela>
                    </div>
                </b-tab>
                <b-tab>
                    <template slot="title">
                        Selecionados
                        <b-badge variant="primary">{{
                            totalSelecionados
                        }}</b-badge>
                    </template>
                    <div class="pt-3">
                        <p
                            class="text-muted text-center my-5"
                            v-if="selecionados.length === 0"
                        >
                            Nenhum item selecionado
                        </p>
                        <app-tabela
                            idTabela="tblSelecionados"
                            :itens="selecionados"
                            :campos="camposSelecionados"
                            :itensPorPagina="itensPorPagina"
                            :mostrarFiltro="false"
                            :bordered="false"
                            :small="true"
                            v-else
                        >
                            <template slot="acoes" slot-scope="data">
                                <span class="text-primary">
                                    <i
                                        class="fa fa-times fa-lg icon-button"
                                        title="Remover da seleção"
                                        @click.stop="$emit('remover', data)"
                                    ></i>
                                </span>
                            </template>
                        </app-tabela>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    statusIntegracao,
    obterStatusIntegracao,
    estaTravado,
    motivoBloqueio,
    STATUS_NAO_INTEGRADO
} from './StatusIntegracao'

export default {
    props: {
        item: {
            type: Object,
            default: null
        },
        subItens: {
            type: Array,
            default: () => []
        },
        selecao: {
            type: Array,
            default: () => []
        },
        selecionados: {
            type: Array,
            default: () => []
        },
        totalSelecionados: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            busca: '',
            statusFiltro: null,
            campos: [
                {
                    key: 'selecao',
                    label: ''
                },
                {
                    key: 'ordem',
                    label: 'Ordem',
                    sortable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição'
                },
                {
                    key: 'statusIntegracao',
                    label: 'Status'
                }
            ],
            camposSelecionados: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'item',
                    label: 'Item Referência',
                    sortable: true
                },
                {
                    key: 'ordem',
                    label: 'Ordem',
                    sortable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição'
                }
            ],
            itensPorPagina: 5
        }
    },

    computed: {
        opcoesStatus() {
            let opcoes = statusIntegracao.map((status) => {
                return { value: status.codigo, text: status.descricao }
            })
            return [{ value: null, text: 'Todos os status' }].concat(opcoes)
        },

        subItensFiltrados() {
            let termo = this.busca ? this.busca.textoNormalizado() : null
            return this.subItens.filter((subItem) => {
                if (
                    this.statusFiltro !== null &&
                    Number(subItem.statusIntegracao) !== this.statusFiltro
                ) {
                    return false
                }
                if (!termo) {
                    return true
                }
                let texto = `${subItem.ordem} ${subItem.descricao}`
                return texto.textoNormalizado().indexOf(termo) !== -1
            })
        },

        naoIntegradosFiltrados() {
            return this.subItensFiltrados.filter((subItem) => {
                return Number(subItem.statusIntegracao) === STATUS_NAO_INTEGRADO
            })
        }
    },

    methods: {
        estaSelecionado(subItem) {
            return this.selecao.some((selecionado) => {
                return selecionado.idSubItem === subItem.idSubItem
            })
        },

        travado(subItem) {
            return estaTravado(subItem.statusIntegracao)
        },

        tituloCheckbox(subItem) {
            return this.travado(subItem)
                ? motivoBloqueio(subItem.statusIntegracao)
                : ''
        },

        descricaoStatus(subItem) {
            return obterStatusIntegracao(subItem.statusIntegracao).descricao
        },

        variante(subItem) {
            return obterStatusIntegracao(subItem.statusIntegracao).variant
        },

        marcarNaoIntegrados() {
            this.$emit('marcarNaoIntegrados', this.naoIntegradosFiltrados)
        }
    },

    watch: {
        item() {
            this.busca = ''
            this.statusFiltro = null
        }
    }
}
</script>
